import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import header from "./it/header.json";
import footer from "./it/footer.json";
import matchmakerwizard from "./it/matchmaker-wizard.json";
import question1page from "./it/question-1-page.json";
import question2page from "./it/question-2-page.json";
import question3page from "./it/question-3-page.json";
import question4page from "./it/question-4-page.json";
import dealerselection from "./it/dealer-selection.json";
import personalinformation from "./it/personal-information.json";
import summarypage from "./it/summary-page.json";
import confirmationpage from "./it/confirmation-page.json";
import errorpage from "./it/error-page.json";
import errormessages from "./it/error-messages.json";
import chi from "./it/chi.json";
import sac from "./it/sac.json";

i18next.use(initReactI18next).init({
    lng: "it",
    resources: {
        it: {
            header,
            matchmakerwizard,
            footer,
            question1page,
            question2page,
            question3page,
            question4page,
            dealerselection,
            personalinformation,
            summarypage,
            confirmationpage,
            errorpage,
            errormessages,
            chi,
            sac
        },
    },
});

export default i18next;
